import { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";

const LeftNav = () => {
  // Initialize as collapsed by default
  const [collapsed, setCollapsed] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // Always start collapsed - set class immediately on mount
    setCollapsed(true);
    document.body.classList.add("leftnav-collapsed");
    
    // Optionally sync with localStorage, but always start collapsed
    try {
      const saved = localStorage.getItem("leftnavCollapsed");
      // Only update if user explicitly saved a preference, but still start collapsed
      // This allows the hover expansion to work
      if (saved === "false") {
        // If user had it expanded, we'll still start collapsed but could expand later
        // For now, we always start collapsed for hover expansion to work
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  const handleMouseEnter = () => {
    setIsHovered(true);
    // Check if body has leftnav-collapsed class directly
    if (document.body.classList.contains("leftnav-collapsed")) {
      document.body.classList.add("leftnav-hover-expanded");
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    // Always remove the hover class on mouse leave
    document.body.classList.remove("leftnav-hover-expanded");
  };

  return (
    <div 
      className="leftnav"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="leftnav-logo">
        <Link to="/">
          <img
            src={require("./../assets/images/icons/athena-logo.png")}
            alt="Athena"
          />
        </Link>
      </div>
      <ul>
        <li>
          <NavLink to="/dashboard">
            <img
              src={require("./../assets/images/icons/icon-saas-demo.png")}
              alt="Decision OS"
              width="30"
            />{" "}
            <span>Decision OS</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/subscription">
            <img
              src={require("./../assets/images/icons/icon-enterprises.png")}
              alt="Subscription"
              width="30"
            />{" "}
            <span>Subscription</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/products">
            <img
              src={require("./../assets/images/icons/icon-products.png")}
              alt="Products"
              width="44"
            />{" "}
            <span>Products</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default LeftNav;
